var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"language-selection"},[_c('a',{class:{ 'hover-effect': true, 'active-language': _vm.currentLanguage == 'de' },on:{"click":function($event){return _vm.setLanguage('de')}}},[_vm._v("DE")])])}
var staticRenderFns = []

export { render, staticRenderFns }